import {utilsModule} from '../utils-module'

utilsModule.factory('serverAddress', [function () {

    //não remova os comentários em caixa alta.
    //são usados pelo grunt para alterar os endereços

    //WEB CONNECTION INIT 
    var webConnection = {
        ip: "NAO_CONFIGURADO",
        port: "",
        nodeIp: "appaws.idha.com.br",
        nodePort: "",
    };
    //WEB CONNECTION END
    //LOCAL CONNECTION INIT 
    var localServerConnection = {
        ip: "NAO_CONFIGURADO",
        port: "",
        nodeIp: "appaws.idha.com.br",
        nodePort: "",
    };
    //LOCAL CONNECTION END

    var contextRoot = "campones";
    var serverAddress:any = {};
    serverAddress.javaURL = "https://api2.idha.com.br:3001/api" + '/pedidos';
    serverAddress.nodeURL = "https://api2.idha.com.br:3001/api";
    serverAddress.managerURL = "https://api2.idha.com.br:3000/api";
    serverAddress.packingURL = "https://api2.idha.com.br:3002/api";
    serverAddress.ordersURL = "https://api2.idha.com.br:3001/api";
    serverAddress.accountsURL = "https://api2.idha.com.br:3103/api";
    


    return serverAddress;
}]);
